export const displayAskGeolocationPanelSelector = ({displayAskGeolocationPanel}) => displayAskGeolocationPanel